import 'react';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import './styled.js';
import { a as Pane } from '../chunk-895bf8c9.js';
export { a as Pane, c as paneDefaultProps, b as panePropTypes } from '../chunk-895bf8c9.js';
export default Pane;